/**
 * Format a number as currency for display.
 * Used by order count lines and other price summaries.
 */
export function formatMoney(value: string | number, currencyCode = 'USD'): string {
  const amount = typeof value === 'number' ? value : parseFloat(value)
  try {
    return amount.toLocaleString('en', {
      style: 'currency',
      currency: currencyCode,
    })
  } catch {
    return amount.toLocaleString('en', { style: 'currency', currency: 'USD' })
  }
}

export function round2dp(value: number): number {
  return Number(value.toFixed(2))
}
